import React, { useState } from "react";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import "../commonSection/commonsection.css";
import RecaptchaComponent from "../commonSection/RecaptchaComponent";
import { submitLeadForm } from "../../redux/actions/micrositeAction";
import { ArrowsAngleContract, ArrowsAngleExpand, ExclamationCircleFill, Link45deg, X } from "react-bootstrap-icons";
import useMicroSiteEncrypt from "../CustomHook/useMicroSiteEncrypt";
import { useDispatch, useSelector } from "react-redux";
import ArrowSvg from "../../assets/CarouselImage/send.svg";
import LinkedInImg from "../../assets/icon_1/in.png"
import EmailIconImg from "../../assets/icon_1/msg.png"
import PhoneIconImg from "../../assets/icon_1/call.png"
import WhatsappIconImg from "../../assets/icon_1/wh.png"
import Facebookmg from "../../assets/icon_1/fb.png"
import TwitterImg from "../../assets/icon_1/x.png"
import SmallCarousel from "../carouselSection/SmallCarousel";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
import { isMobile } from "react-device-detect";
import { parsePhoneNumber } from "react-phone-number-input";
import { getNewRecaptchaToken } from '../commonSection/RecaptchaComponent';



export default function MainProfile(props) {
    const dispatch = useDispatch();
    const [recaptchaToken, setRecaptchaToken] = useState("");
    const [copied, setCopied] = useState(false);
    const [open, setOpen] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [countryCode, setCountryCode] = useState("+91");
    const [mobile, setMobile] = useState("");
    const [nameError, setNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [mobileError, setMobileError] = useState("");
    const { microSiteEncrypt } = useMicroSiteEncrypt();
    const url_data = useSelector((state) => state.microsite?.url_data);
    const current_flow = useSelector((state) => state.microsite?.home_data?.flow);
    const [recaptchaKey, setRecaptchaKey] = useState(0);
    const customize_fields = useSelector(
        (state) => state.microsite?.home_data?.customization
    );
    const microsite_clt = useSelector(
        (state) => state.microsite?.home_data?.new_microsite_extra_clt
    );
    const [isOpen, setIsOpen] = useState(false);

    const captcha_key =
        window.location.origin.includes("spdevmfp") ||
        window.location.origin.includes("localhost")
            ? "6LfunNgbAAAAAEM0X3hcwSBYKJwIqHmmInfz0uFK"
            : window.location.origin.includes("sppreprod") ||
            window.location.origin.includes("sptestmfp")
            ? "6Ldeg6YaAAAAAAZqU7AQ_j-lG4LcnwP4jfNFiCJJ"
            : "6Lf9fqoaAAAAAH8JhnTg9gLI3KsYKmR2tdCRVg8i";

    const toggleCard = () => {
        setIsOpen(!isOpen);
    };

    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return "";
        const match = phoneNumber.match(/^(\+\d+)(.*)$/);
        if (match) {
            const [_, countryCode, number] = match;
            return `${countryCode}-${number}`;
        }
        return phoneNumber;
    };

    const handleCountryChange = (value) => {
        if (value) {
            try {
                const phoneNumberObj = parsePhoneNumber(value);
                const newCountryCode = '+' + phoneNumberObj?.countryCallingCode;
                setCountryCode(newCountryCode);
            } catch (error) {
                console.error('Invalid phone number', error);
            }
        } else {
            setCountryCode('');
        }
    };

    const submitForm = async () => {
        if (
            name === "" &&
            customize_fields?.top_contact?.name?.validation === "required"
        ) {
            setNameError(true);
            return;
        } else if (
            (mobile === "" || mobileError) &&
            customize_fields?.top_contact?.phone?.validation === "required"
        ) {
            setMobileError(true);
            return;
        } else if (emailError) {
            setEmailError(true);
            return;
        } else {
            setNameError(false);
            setEmailError(false);
            setMobileError(false);
        }

        // Get fresh recaptcha token for lead form
        const freshRecaptchaToken = await getNewRecaptchaToken(captcha_key);

        let payload = {
            fullname: name,
            phoneNo: mobile ? `${countryCode}-${mobile.replace(countryCode, '')}` : "",
            emailId: email,
            recaptcha_token: freshRecaptchaToken,
            url: url_data,
        };

        const generateToken = async () => {
            const token = await microSiteEncrypt(payload);
            if (token && token !== "") {
                dispatch(
                    submitLeadForm(
                        token,
                        payload,
                        "Profile",
                        current_flow,
                        onSuccess
                    )
                );
            }
        };

        generateToken();
    };
    
    const refreshRecaptcha = () => {
        setRecaptchaKey(prev => prev + 1);
    };

    const handleRedirect = (address) => {
        if (address.trim()) {
        const encodedAddress = encodeURIComponent(address);
        const url = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
        const newWindow = window.open(url, '_blank');
            if (newWindow) {
                newWindow.opener = null;
            }
        }
    };
    
    
    const handleFacebookRedirect = (url) => {
        if (url.trim()) {
            const newWindow = window.open(url, '_blank');
            if (newWindow) {
                newWindow.opener = null;
            }
        }
    };
    
    const handleLinkedinRedirect = (url) => {
        if (url.trim()) {
            const newWindow = window.open(url, '_blank');
            if (newWindow) {
                newWindow.opener = null;
            }
        }
    };
    
    const handleWhatsappRedirect = (phoneNumber) => {
        if (phoneNumber.trim()) {
        const encodedMessage = encodeURIComponent("");
        const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        const newWindow = window.open(url, '_blank');
        if (newWindow) {
            newWindow.opener = null;
        }
        }
    };
    
    const handleEmailRedirect = (email) => {
        if (email.trim()) {
        const encodedSubject = encodeURIComponent("");
        const encodedMessage = encodeURIComponent("");
        const mailtoUrl = `mailto:${email}?subject=${encodedSubject}&body=${encodedMessage}`;
        const newWindow = window.open(mailtoUrl, '_blank');
        if (newWindow) {
            newWindow.opener = null;
        }
        }
    };
    
    const handleCallRedirect = (phoneNumber) => {
        if (phoneNumber.trim()) {
        const telUrl = `tel:${phoneNumber}`;
        window.location.href = telUrl;
        }
    };
    
    const handleCopy = () => {
        toast.success("Link copied to clipboard!");
    };
    
    const onSuccess = () => {
        setName("");
        setEmail("");
        setMobile("+91");
        refreshRecaptcha();
    };

    // Add this style block for the dynamic gradient
    const gradientStyle = {
        background: `linear-gradient(${props?.colors?.primary}, ${props?.colors?.primary})`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        lineHeight: 'normal'
    };
    // Choose only ONE among Facebook, LinkedIn, Twitter (in that priority or adjust below)
    const renderOneSocialIcon = () => {
        const d = props.data || {};
        if (d?.facebook_page) {
            return (
                <img
                    onClick={() => { handleFacebookRedirect(d.facebook_page); }}
                    src={Facebookmg}
                    className="w-10 h-10 cursor-pointer"
                    alt="facebook"
                />
            );
        }
        if (d?.linkedin_page) {
            return (
                <img
                    onClick={() => { handleLinkedinRedirect(d.linkedin_page); }}
                    src={LinkedInImg}
                    className="w-10 h-10 cursor-pointer"
                    alt="linkedin"
                />
            );
        }
        if (d?.twitter_page) {
            return (
                <img
                    onClick={() => { handleFacebookRedirect(d.twitter_page); }}
                    src={TwitterImg}
                    className="w-10 h-10 cursor-pointer"
                    alt="twitter"
                />
            );
        }
        return null;
    };

    return (
        <div className="py-8 max-sm:pt-4">
            <div className="max-h-[550px] flex max-sm:block items-center justify-start pl-16 max-sm:px-4 mx-auto lg:max-w-7xl">
                <div className="bg-gray-100 p-4 hidden max-sm:block rounded-xl mb-8">
                    <div className="flex">
                        <img
                            alt=""
                            src={props.data?.profile_image}
                            className="h-28 w-28 rounded-xl"
                        />
                        <div className="px-4 max-sm:text-left space-y-1.5">
                            <h3 className="text-black text-2xl not-italic font-bold leading-7">
                                {props.data?.name}
                            </h3>
                            <p style={{color: props?.colors?.primary}} className="text-sm not-italic font-bold leading-5">
                                {props.data?.designation}
                            </p>

                            <p className="text-[12px] text-[#00000070] not-italic font-medium whitespace-nowrap cursor-pointer" onClick={() => { handleEmailRedirect(props.data?.email) }}>
                                <img src={process.env.PUBLIC_URL + '/email.svg'} className="w-[15px] h-[10px] inline-block mr-1" alt="email" /> {props.data?.email}
                            </p>
                            <p className="text-[12px] text-[#00000070] not-italic font-medium whitespace-nowrap cursor-pointer" onClick={() => { handleCallRedirect(props.data?.contact) }}>
                                <img src={process.env.PUBLIC_URL + '/phone.svg'} className="w-[15px] h-[11px] inline-block mr-1" alt="phone call" />  {props.data?.contact}
                            </p>
                         </div>
                    </div>
                    <div className="flex justify-between py-1">

                        {props.data?.contact && <img onClick={() => { handleCallRedirect(props.data?.contact) }} src={PhoneIconImg} className="w-10 h-10 cursor-pointer mt-2" alt="Phone Call" />}
                        {props.data?.contact && <img onClick={() => { handleWhatsappRedirect(props.data?.contact) }} src={WhatsappIconImg} className="w-10 h-10 cursor-pointer mt-2" alt="Whatsapp" />}
                        {props.data?.email && <img onClick={() => { handleEmailRedirect(props.data?.email) }} src={EmailIconImg} className="w-10 h-10 cursor-pointer mt-2" alt="email" />}
                        {props.data?.linkedin_page && <img onClick={() => { handleLinkedinRedirect(props.data?.linkedin_page) }} src={LinkedInImg} className="w-10 h-10 cursor-pointer rounded-full mt-2" alt="linkedin" />}
                        {props.data?.facebook_page && <img onClick={() => { handleFacebookRedirect(props.data?.facebook_page) }} src={Facebookmg} className="w-10 h-10 cursor-pointer mt-2" alt="Facebook" />}
                        {props.data?.twitter_page && <img onClick={() => { handleFacebookRedirect(props.data?.twitter_page) }} src={TwitterImg} className="w-10 h-10 cursor-pointer mt-2" alt="Twitter" />}
                        
                        <div onClick={()=>{setOpen(true)}} style={{backgroundColor: props?.colors?.primary}} className="cursor-pointer h-10 w-10 rounded-full flex items-center mt-2 justify-center">
                            <ArrowsAngleExpand className="text-[#fff] text-xl"/>
                        </div>
                    </div>
                </div>
                
                <div className="w-2/3 max-sm:w-full text-left max-sm:text-center">
                    <style>
                        {`
                            .gradient-blue {
                                background: linear-gradient(${props?.colors?.primary}, ${props?.colors?.primary});
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                                line-height: normal;
                            }
                            
                            .country-customize input:focus{
                                border-color: ${props?.colors?.secondary};
                            }
                            .custom_ring_color:focus {
                                border-color: ${props?.colors?.secondary};
                                --tw-ring-color: ${props?.colors?.secondary};
                            }
                        

                        `}
                    </style>
                    <div dangerouslySetInnerHTML={{__html:props?.ticker?.replaceAll("className","class")}}></div>
                    <div className="flex max-sm:block items-center gap-4 my-12 max-sm:mb-0 w-[80%] max-sm:w-full max-sm:px-4">
                       
                        <div className={`${microsite_clt?.let_discuss === "Let's Discuss" ? 'w-1/6' : 'w-1/3'} max-sm:w-full text-[#444] text-sm max-sm:mb-4 font-semibold`}> 
                       
                        {microsite_clt?.let_discuss || "Let's discover the best option for you."}
                       
                        </div>
                        <form className="w-3/4 max-sm:w-full" action="#" method="POST">
                            <div className="">
                                <div className='flex max-sm:block items-center gap-4'>
                                    <div className='w-1/2 max-sm:w-full'>
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="name"
                                                id="name"
                                                className={`block border shadow-md rounded-md border-[#e5e7eb] bg-white w-full font-[HelveticaNeueLTStd] h-9 max-sm:h-12 py-1.5 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-inset custom_ring_color focus:border-none sm:text-xs sm:leading-6`}
                                                value={name}
                                                placeholder={"Your name?" + (customize_fields?.whatsapp_contact?.name?.validation == "required" ? " *":"")}
                                                onChange={(e) => {
                                                    const regex = /^[a-zA-Z ]*$/;
                                                    if (regex.test(e.target.value)) {
                                                        setName(e.target.value);
                                                    }
                                                    if (e.target.value != "") {
                                                        setNameError(false);
                                                    }
                                                }}
                                            />
                                            {nameError != false && <ExclamationCircleFill title="Enter a name" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5" />}
                                        </div>
                                    </div>
                                    <div className='w-1/2 max-sm:flex max-sm:mt-4 max-sm:w-full'>
                                        <div className="relative max-sm:w-[80%] country-customize profile delay-form">
                                            <PhoneInput
                                                flags={flags}
                                                className='font-[HelveticaNeueLTStd]'
                                                placeholder={"Your mobile number?" + (customize_fields?.whatsapp_contact?.name?.validation == "required" && " *")}
                                                value={mobile}

                                                defaultCountry="IN"
                                                countryCallingCodeEditable={false}
                                                international={true}
                                                limitMaxLength
                                               
                                                onChange={(e) => {
                                                    if (e) {
                                                        setMobile(e);
                                                        handleCountryChange(e);
                                                        if (isValidPhoneNumber(e)) {
                                                            setMobileError(false);
                                                        } else {
                                                            setMobileError(true);
                                                        }
                                                    } else {
                                                        setMobile("");
                                                        setCountryCode("");
                                                        setMobileError(false);
                                                    }
                                                }}
                                                
                                            />
                                            {mobileError != false && <ExclamationCircleFill title="Enter a valid mobile number" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5" />}
                                        </div>
                                        <div className="max-sm:w-[20%] max-sm:block hidden">
                                            <button
                                                type="button"
                                                onClick={submitForm}
                                                style={{backgroundColor: props?.colors?.secondary}}
                                                className={`flex w-auto ml-auto mt-1 items-center border p-2.5 rounded-[30px] border-solid border-[#fff]`}
                                            >
                                                <img src={ArrowSvg} alt="arrow" className="text-[#cb8545] text-xl"/>
                                            </button>
                                        </div>    
                                    </div>
                                </div>
                                <RecaptchaComponent key={recaptchaKey} onVerify={setRecaptchaToken} />
                            </div>
                        </form>
                        <button
                            type="button"
                            onClick={submitForm}
                            style={{backgroundColor: props?.colors?.secondary}}
                            className={`flex w-auto max-sm:hidden items-center border p-2.5 rounded-[30px] border-solid border-[#fff]`}
                        >
                            <img src={ArrowSvg} alt="arrow" className="text-[#cb8545] text-xl"/>
                        </button>
                    </div>    
                </div>
                <div className="w-1/3 text-left max-sm:hidden">
                    <div style={{backgroundColor: props?.colors?.primary}} className="w-[70%] relative rounded-xl mx-auto space-y-3">
                        <div>
                            <img
                                alt=""
                                src={props.data?.profile_image}
                                className="mx-auto h-68 w-full rounded-t-xl"
                            />
                            <div className="px-4 pb-4 space-y-1 mt-2">
                                <h3 className="text-white text-3xl not-italic font-medium leading-10">
                                    {props.data?.name}
                                </h3>
                                <p className="text-white text-base not-italic font-medium leading-6">{props.data?.designation}</p>
                                <div className="flex justify-between py-1 mx-auto">
                                    {props.data?.contact && (
                                        <img onClick={() => { handleCallRedirect(props.data?.contact) }} src={PhoneIconImg} className="w-10 h-10 cursor-pointer" alt="Phone Call" />
                                    )}
                                    {props.data?.contact && (
                                        <img onClick={() => { handleWhatsappRedirect(props.data?.contact) }} src={WhatsappIconImg} className="w-10 h-10 cursor-pointer" alt="Whatsapp" />
                                    )}
                                    {props.data?.email && (
                                        <img onClick={() => { handleEmailRedirect(props.data?.email) }} src={EmailIconImg} className="w-10 h-10 cursor-pointer" alt="email" />
                                    )}
                                    {renderOneSocialIcon()}
                                    
                                   
                                   
                                    
                                    <div>
                                        <div style={{ backgroundColor: props?.colors?.secondary }} onClick={toggleCard} className="bg-[#2167A7] h-[38px] w-[38px] cursor-pointer border-[#b8b8b8] border-2 rounded-full flex items-center justify-center"><ArrowsAngleExpand className='text-[#b8b8b8] text-xl' /></div>
                                        <span className="text-gray-300 text-[8.5px]">View more</span>
                                    </div>
                                </div>
                            </div>
                            {/* <span
                                onClick={toggleCard}
                                className={`absolute -left-5 top-1/2 bg-[#E85325] transform -translate-y-1/2 cursor-pointer rounded-full`}
                            >
                                <ArrowLeft className={`p-2 text-[40px] transition-all text-white duration-500 ease-in-out`} />
                            </span> */}
                        </div>
                        <div className={`w-[200%] ${props?.microsite_clt?.achievement_hide ===1 ? '' : 'h-fit'}  border border-[#d9d9d9] shadow-[0px_0px_30px_5px_#95bed4] transition-all duration-500 ease-in-out bg-white absolute -top-3 rounded-xl -left-full ${isOpen ? "opacity-100 z-1":"opacity-0 -z-10"}`}>
                            <div className="flex">
                                <div className="w-1/2">
                                    <img
                                        alt=""
                                        src={props.data?.profile_image}
                                        className="mx-auto h-68 p-4 w-full rounded-t-xl"
                                    />
                                    {props?.microsite_clt?.achievement_hide !=1 &&
                                    <div className="h-[100px]">
                                        <SmallCarousel achievementData={props.achivements}/>
                                    </div>
                                    }
                                    {/* <span
                                        onClick={toggleCard}
                                        className={`absolute -left-5 top-1/2 bg-[#E85325] transform -translate-y-1/2 cursor-pointer rounded-full`}
                                    >
                                        <ArrowRight className={`p-2 text-[40px] transition-all text-white duration-500 ease-in-out`} />
                                    </span> */}
                                </div>
                                <div className="w-1/2 before:border-l before:h-full before:absolute before:border-[#d9d9d9]">
                                    <div className="px-4 pb-4 flex flex-col h-full justify-between">
                                        <div className="space-y-3">
                                            <h3 className="text-black text-3xl not-italic font-medium leading-10">
                                                {props.data?.name}
                                            </h3>
                                            <p style={{color: props?.colors?.primary}} className="text-[#2167A7] text-base not-italic font-medium leading-6 capitalize">
                                                {props.data?.designation?.toLowerCase()}
                                            </p>
                                            <div className="overflow-y-auto max-h-[250px] scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                                                <p className="text-[#00000070] text-sm not-italic font-normal leading-[132%]">
                                                    {props.data?.about}
                                                </p>
                                            </div>
                                        </div>
                                        
                                        <div className="grid grid-cols-5 py-1 mt-4">
                                            {props.data?.contact && <img onClick={() => { handleCallRedirect(props.data?.contact) }} src={PhoneIconImg} className="w-10 h-10 cursor-pointer mt-2" alt="Phone Call" /> }
                                            {props.data?.contact && <img onClick={() => { handleWhatsappRedirect(props.data?.contact) }} src={WhatsappIconImg} className="w-10 h-10 cursor-pointer mt-2" alt="whatsapp" />}
                                            {props.data?.email && <img onClick={() => { handleEmailRedirect(props.data?.email) }} src={EmailIconImg} className="w-10 h-10 cursor-pointer mt-2" alt="email" />}
                                            {props.data?.facebook_page && <img onClick={() => { handleFacebookRedirect(props.data?.facebook_page) }} src={Facebookmg} className="w-10 h-10 cursor-pointer mt-2" alt="facebook" />}
                                            {props.data?.linkedin_page && <img onClick={() => { handleLinkedinRedirect(props.data?.linkedin_page) }} src={LinkedInImg} className="w-10 h-10 cursor-pointer rounded-full mt-2" alt="linkedin" />}
                                            {props.data?.twitter_page && <img onClick={() => { handleFacebookRedirect(props.data?.twitter_page) }} src={TwitterImg} className="w-10 h-10 cursor-pointer mt-2" alt="twitter" />}
                                            <CopyToClipboard text={props.url} onCopy={handleCopy}>
                                                <Link45deg className='text-[39px] mt-2 cursor-pointer text-[#b8b8b8] p-1 bg-[#fff] border-2 border-[#b8b8b8] rounded-full'/>
                                            </CopyToClipboard>
                                            <div onClick={toggleCard} style={{backgroundColor: props?.colors?.secondary}} className="bg-[#2167A7] cursor-pointer h-10 w-10 rounded-full flex items-center mt-2 justify-center">
                                                <ArrowsAngleContract className="text-[#fff] text-xl"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
            
            <Transition show={open}>
                <Dialog className="relative z-10" onClose={setOpen}>
                <TransitionChild
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <DialogPanel className="relative transform overflow-hidden rounded-lg bg-[#fefefe] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl">
                            <div className="p-4 space-y-4">
                                <div className="flex">
                                    <img
                                        alt=""
                                        src={props.data?.profile_image}
                                        className="h-28 w-28 rounded-xl"
                                    />
                                    <div className="px-4 max-sm:text-left space-y-1.5">
                                        <h3 className="text-black text-2xl not-italic font-bold leading-7">
                                            {props.data?.name}
                                        </h3>
                                        <p style={{color: props?.colors?.primary}} className="text-[#2167A7] text-sm not-italic font-bold leading-5">{props.data?.designation}</p>
                                    </div>
                                </div>
                                
                                <div className="overflow-y-auto max-h-[150px] scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                                    <p className="text-[#00000070] text-sm not-italic font-normal leading-[132%]">
                                        {props.data?.about}
                                    </p>
                                </div>
                                        
                                {props?.microsite_clt?.achievement_hide !=1 &&       
                                    <div className="h-[80px]">
                                        <SmallCarousel achievementData={props.achivements}/>
                                    </div>        
                                }
                                <div className="mt-auto">
                                    <div className="grid grid-cols-6 py-1 mt-10">
                                        {props.data?.contact && <img onClick={() => { handleCallRedirect(props.data?.contact) }} src={PhoneIconImg} className="w-10 h-10 mx-auto cursor-pointer mt-2" alt="phone call" />}
                                        {props.data?.contact && <img onClick={() => { handleWhatsappRedirect(props.data?.contact) }} src={WhatsappIconImg} className="w-10 h-10 mx-auto cursor-pointer mt-2" alt="whatsapp" />} 
                                        {props.data?.email && <img onClick={() => { handleEmailRedirect(props.data?.email) }} src={EmailIconImg} className="w-10 h-10 mx-auto cursor-pointer mt-2" alt="email" />}
                                        {props.data?.linkedin_page && <img onClick={() => { handleLinkedinRedirect(props.data?.linkedin_page) }} src={LinkedInImg}  className="w-10 h-10 mx-auto cursor-pointer rounded-full mt-2" alt="linkedin" />}
                                        {props.data?.facebook_page && <img onClick={() => { handleFacebookRedirect(props.data?.facebook_page) }} src={Facebookmg} className="w-10 h-10 mx-auto cursor-pointer mt-2" alt="facebook" />}
                                        {props.data?.twitter_page && <img onClick={() => { handleFacebookRedirect(props.data?.twitter_page) }} src={TwitterImg} className="w-10 h-10 mx-auto cursor-pointer mt-2" alt="twitter" />}
                                        
                                        <CopyToClipboard text={props.url} onCopy={handleCopy}>
                                            <Link45deg className='text-[39px] mx-auto mt-2 cursor-pointer text-[#b8b8b8] p-1 bg-[#fff] border-2 border-[#b8b8b8] rounded-full'/>
                                        </CopyToClipboard>
                                        <div onClick={()=>{setOpen(false)}} style={{backgroundColor: props?.colors?.primary}} className="bg-[#2167A7] mx-auto cursor-pointer h-10 w-10 rounded-full flex items-center mt-2 justify-center">
                                            <ArrowsAngleContract className="text-[#fff] text-xl"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                    </div>
                </div>
                </Dialog>
            </Transition>
        </div>


    );
}
